export default "__VITE_ASSET__Dhipi_pi__"